export default {
  mrp: {
    section: {
      grayPaddingTopLargeMultiplier: 4,
      grayPaddingTopXLargeMultiplier: 10,
      grayPaddingBottomLargeMultiplier: 4,
      grayPaddingBottomXLargeMultiplier: 10
    }
  },
  nap: {
    paragraph: {
      name: '3',
    },
    section: {
      grayMarginTopSmallMultiplier: 0,
      grayMarginTopMediumMultiplier: 0,
      grayMarginTopLargeMultiplier: 0,
      grayMarginTopXLargeMultiplier: 0,
      grayPaddingTopSmallMultiplier: 6,
      grayPaddingTopMediumMultiplier: 10,
      grayPaddingTopLargeMultiplier: 10,
      grayPaddingTopXLargeMultiplier: 10,
    }
  },
  ton: {}
}